import { useCallback } from "react";
import {
  FormControl,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormHelperText,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { isFieldVisible } from "./formUtils";

const RFQOverview = ({
  countrymaster,
  incotermsMaster,
  paymentTermMaster,
  formData,
  errors,
  handleChange,
  formMode,
  currentDate,
  loadFormPorts,
  selectedTradeRFQ,
  buyerInfo,
}) => {
  const handleOriginChange = useCallback(
    (e) => {
      const country = e.target.value;
      handleChange(e);
      if (country) {
        loadFormPorts(country, "origin");
      }
    },
    [handleChange, loadFormPorts]
  );

  const handleDeliveryChange = useCallback(
    (e) => {
      const country = e.target.value;
      handleChange(e);
      if (country) {
        loadFormPorts(country, "delivery");
      }
    },
    [handleChange, loadFormPorts]
  );

  return (
    <div className="tab-pane active">
      <div className="row g-3">
        {isFieldVisible("applicantName", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.applicantName}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">
                Applicant Name (Global Partner)
              </Typography>
              <TextField
                name="applicantName"
                value={formData.applicantName}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Applicant Name" }}
                disabled={formMode === "view"}
              />
              {errors.applicantName && (
                <FormHelperText>{errors.applicantName}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("beneficiaryName", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.beneficiaryName}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">Beneficiary Name (Seller)</Typography>
              <TextField
                name="beneficiaryName"
                value={formData.beneficiaryName}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Beneficiary Name" }}
                disabled={formMode === "view"}
              />
              {errors.beneficiaryName && (
                <FormHelperText>{errors.beneficiaryName}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("lcAmount", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.lcAmount}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">LC Amount</Typography>
              <TextField
                name="lcAmount"
                type="number"
                step="any"
                value={formData.lcAmount}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "LC Amount" }}
                disabled={formMode === "view"}
              />
              {errors.lcAmount && (
                <FormHelperText>{errors.lcAmount}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("lcCurrency", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.lcCurrency}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">Currency</Typography>
              <TextField
                name="lcCurrency"
                value={formData.lcCurrency}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Currency" }}
                // disabled={formMode === "view"}
                disabled={true}
              />
              {/* <Select
                name="lcCurrency"
                value={formData.lcCurrency}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Select Currency" }}
                // disabled={formMode === "view"}
                disabled={true}
              >
                <MenuItem value="" disabled>
                  Select Currency
                </MenuItem>
                {["USD", "EUR", "INR", "GBP", "JPY"].map((currency) => (
                  <MenuItem key={currency} value={currency}>
                    {currency}
                  </MenuItem>
                ))}
              </Select> */}
              {errors.lcCurrency && (
                <FormHelperText>{errors.lcCurrency}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("lcType", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.lcType}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">Type of LC</Typography>
              <RadioGroup
                row
                name="lcType"
                value={formData.lcType}
                onChange={handleChange}
              >
                {["Sight", "Usance", "Back-to-Back"].map((type) => (
                  <FormControlLabel
                    key={type}
                    value={type}
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#de6b14",
                          "&.Mui-checked": {
                            color: "#de6b14",
                          },
                        }}
                      />
                    }
                    label={type}
                  />
                ))}
              </RadioGroup>
              {errors.lcType && (
                <FormHelperText>{errors.lcType}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("lcTenor", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              disabled={formMode === "view"}
              error={!!errors.lcTenor}
            >
              <Typography variant="body2">
                LC Tenor / Maturity Period
              </Typography>
              <TextField
                name="lcTenor"
                value={formData.lcTenor}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                placeholder="e.g., 90 days, 6 months"
                inputProps={{ "aria-label": "LC Tenor" }}
                disabled={formMode === "view"}
              />
              {errors.lcTenor && (
                <FormHelperText>{errors.lcTenor}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("incoterm", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.incoterm}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">Incoterm</Typography>
              {formMode === "view" ? (
                <TextField
                  value={formData.incoterm}
                  disabled={true}
                  sx={{ backgroundColor: "white", width: "100%" }}
                  placeholder="category selected"
                />
              ) : (
                <Select
                  name="incoterm"
                  value={formData.incoterm}
                  onChange={handleChange}
                  size="small"
                  sx={{ backgroundColor: "white" }}
                  inputProps={{ "aria-label": "Select Incoterm" }}
                >
                  <MenuItem value="" disabled>
                    Select Incoterm
                  </MenuItem>
                  {incotermsMaster.map((p) => (
                    <MenuItem key={p.ID} value={p.Value}>
                      {p.Value}
                    </MenuItem>
                  ))}
                </Select>
              )}
              {errors.incoterm && (
                <FormHelperText>{errors.incoterm}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("countryOrigin", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.countryOrigin}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">Country of Origin</Typography>
              <FormControl sx={{ minWidth: "100%" }}>
              {formMode === "view" ? (
                <TextField
                  value={formData.countryOrigin}
                  disabled={true}
                  sx={{ backgroundColor: "white", width: "100%" }}
                  placeholder="category selected"
                />
              ) : (
                <Select
                  name="countryOrigin"
                  value={formData.countryOrigin}
                  onChange={handleOriginChange}
                  displayEmpty
                  sx={{ backgroundColor: "white" }}
                  disabled={formMode === "view"}
                >
                  <MenuItem value="" disabled>
                    Select Origin Country
                  </MenuItem>
                  {countrymaster.map((c) => (
                    <MenuItem key={c.ID} value={c.Value}>
                      {c.Value}
                    </MenuItem>
                  ))}
                </Select>
              )}
              </FormControl>
              {errors.countryOrigin && (
                <FormHelperText>{errors.countryOrigin}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "countryDestination",
          formData.instrument,
          formData
        ) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.countryDestination}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">Country of Destination *</Typography>
              <FormControl sx={{ minWidth: "100%" }}>
              {formMode === "view" ? (
                <TextField
                  value={formData.countryDestination}
                  disabled={true}
                  sx={{ backgroundColor: "white", width: "100%" }}
                  placeholder="category selected"
                />
              ) : (
                <Select
                  name="countryDestination"
                  value={formData.countryDestination}
                  onChange={handleDeliveryChange}
                  displayEmpty
                  sx={{ backgroundColor: "white" }}
                  disabled={formMode === "view"}
                >
                  <MenuItem value="" disabled>
                    Select Destination Country
                  </MenuItem>
                  {countrymaster.map((c) => (
                    <MenuItem key={c.ID} value={c.Value}>
                      {c.Value}
                    </MenuItem>
                  ))}
                </Select>
              )}
              </FormControl>
              {errors.countryDestination && (
                <FormHelperText>{errors.countryDestination}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("goodsDescription", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.goodsDescription}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">Goods/Service Description</Typography>
              <textarea
                id="goodsDescription"
                className="form-control"
                rows="2"
                name="goodsDescription"
                value={formData.goodsDescription}
                onChange={handleChange}
                disabled={formMode === "view"}
              />
              {errors.goodsDescription && (
                <FormHelperText>{errors.goodsDescription}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible(
          "lcOpeningBankDetails",
          formData.instrument,
          formData
        ) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.lcOpeningBankDetails}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">LC Opening Bank Details</Typography>
              <TextField
                name="lcOpeningBankDetails"
                value={formData.lcOpeningBankDetails}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "LC Opening Bank Details" }}
                disabled={formMode === "view"}
              />
              {errors.lcOpeningBankDetails && (
                <FormHelperText>{errors.lcOpeningBankDetails}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("expiryDate", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.expiryDate}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">Expiry / Validity Date</Typography>
              <TextField
                name="expiryDate"
                type="date"
                value={formData.expiryDate || currentDate}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Expiry Date" }}
                disabled={formMode === "view"}
              />
              {errors.expiryDate && (
                <FormHelperText>{errors.expiryDate}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
        {isFieldVisible("paymentTerms", formData.instrument, formData) && (
          <div className="col-md-4">
            <FormControl
              fullWidth
              error={!!errors.paymentTerms}
              disabled={formMode === "view"}
            >
              <Typography variant="body2">Payment Terms</Typography>
              {formMode === "view" ? (
                <TextField
                  value={formData.paymentTerms}
                  disabled={true}
                  sx={{ backgroundColor: "white", width: "100%" }}
                  placeholder="category selected"
                />
              ) : (
              <Select
                name="paymentTerms"
                value={formData.paymentTerms}
                onChange={handleChange}
                size="small"
                sx={{ backgroundColor: "white" }}
                inputProps={{ "aria-label": "Select Payment Terms" }}
                disabled={formMode === "view"}
              >
                <MenuItem value="" disabled>
                  Select Payment Terms
                </MenuItem>
                {paymentTermMaster.map((p) => (
                  <MenuItem key={p.ID} value={p.Value}>
                    {p.Value}
                  </MenuItem>
                ))}
              </Select>
              )}
              {errors.paymentTerms && (
                <FormHelperText>{errors.paymentTerms}</FormHelperText>
              )}
            </FormControl>
          </div>
        )}
      </div>
    </div>
  );
};

export default RFQOverview;
